import { render, staticRenderFns } from "./PluginManage.vue?vue&type=template&id=7dec21e1&scoped=true"
import script from "./PluginManage.vue?vue&type=script&lang=js"
export * from "./PluginManage.vue?vue&type=script&lang=js"
import style0 from "./PluginManage.vue?vue&type=style&index=0&id=7dec21e1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dec21e1",
  null
  
)

export default component.exports